export default __webpack_public_path__ + "static/media/pencil.3000c0f3.png";